import React from 'react';

const Partners = () => {
  const partners = [
    {
      logo: "/images/partners/fiberhome.png",
      type: "image"
    },
    {
      logo: "/images/partners/iconnet.png",
      type: "image"
    },
    {
      logo: "/images/partners/iforte.png",
      type: "image"
    },
    {
      logo: "/images/partners/indosat.png",
      type: "image"
    },
    {
      logo: "/images/partners/telkomsel.png",
      type: "image"
    },
    {
      logo: "/images/partners/towerbersama.png",
      type: "image"
    },
    {
      logo: "/images/partners/xl.png",
      type: "image"
    },
    {
      logo: "/images/partners/myrepublic.png",
      type: "image"
    },
    {
      logo: "/images/partners/telkomakses.png",
      type: "image"
    },
     {
      logo: "/images/partners/surge.png",
      type: "image"
    },
  ];

  // Duplicate the partners array to create seamless loop
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section id="partners" className="partners">
      <div className="container">
        <div className="section-header">
          <h2>Our Clients</h2>
          <p>Mitra Utama Kami</p>
        </div>
        
        <div className="partners-carousel">
          <div className="partners-track">
            {duplicatedPartners.map((partner, index) => (
              <div key={index} className="partner-logo-item">
                <img 
                  src={partner.logo} 
                  alt={`Partner ${index + 1}`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;